/** Finance menu for the bursar portal (mirrors director fee + expense steps). */

export const BURSAR_FINANCE_NAV = [
    {
        to: "/Teacher/fees/structures",
        label: "Fee setup",
        hint: "Set fees per class",
        match: (p) => p.startsWith("/Teacher/fees/structures"),
    },
    {
        to: "/Teacher/fees/collection",
        label: "Collect fees",
        hint: "Record payments",
        match: (p) => p.startsWith("/Teacher/fees/collection") || p.startsWith("/Teacher/fees/record"),
    },
    {
        to: "/Teacher/fees/payment-submissions",
        label: "Verify student payments",
        hint: "Confirm cash-in, transfer & balance",
        match: (p) => p.startsWith("/Teacher/fees/payment-submissions"),
    },
    {
        to: "/Teacher/fees/defaulters",
        label: "Fee defaulters",
        hint: "Balances owing",
        match: (p) => p.startsWith("/Teacher/fees/defaulters"),
    },
    {
        to: "/Teacher/fees/aids",
        label: "Waivers & bursaries",
        hint: "Scholarships, subsidies & fee aids",
        match: (p) => p.startsWith("/Teacher/fees/aids"),
    },
    {
        to: "/Teacher/fees/reports",
        label: "Fee reports",
        hint: "Collections summary",
        match: (p) => p.startsWith("/Teacher/fees/reports"),
    },
    {
        to: "/Teacher/expenses/log",
        label: "Expense book",
        hint: "Record spending",
        match: (p) => p.startsWith("/Teacher/expenses/log") || p.includes("/Teacher/expenses/detail"),
    },
    {
        to: "/Teacher/expenses/budgets",
        label: "Budgets",
        hint: "Planned spending",
        match: (p) => p.startsWith("/Teacher/expenses/budgets"),
    },
    {
        to: "/Teacher/expenses/summary",
        label: "Expense reports",
        hint: "Summaries",
        match: (p) => p.startsWith("/Teacher/expenses/summary"),
    },
];
